/**
 * Enum of orientation (HORIZONTAL | VERTICAL)
 * @enum {string}
 */
const ORIENTATION = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical'
}

export { ORIENTATION }
